import _ from 'lodash';

const UPDATE_REQUIREMENT_STATUS = 418;

const reloadPage = () => window.location.reload(true);

const versionGuardMiddleware = () => next => action => {
  if (action.axios) {
    const status = _.get(action, 'payload.status');
    if (_.isNumber(status) && status === UPDATE_REQUIREMENT_STATUS) {
      reloadPage();
    }
  }

  if (action.error) {
    const status = _.get(action, 'payload.http_status') || _.get(action, 'payload.status');
    if (_.isNumber(status) && status === UPDATE_REQUIREMENT_STATUS) {
      reloadPage();
    }
  }
  return next(action);
};

export default versionGuardMiddleware;
